module.exports = __webpack_public_path__ + "img/jialiwuliu.818fe72.webp";